import BaseService from '../BaseService.js'

export default class GasService extends BaseService {

  constructor() {
    super('gas')
  }

  async getFluesse(date) {
    await this.getBackendListUrl('fluesse').then(url => this.serviceurl = url)
    return this.checkError(
      fetch(`${this.serviceurl}?date=${date}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }
}
